import { render, staticRenderFns } from "./ContentTypeNewAttributeBtn.vue?vue&type=template&id=0703e866"
import script from "./ContentTypeNewAttributeBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentTypeNewAttributeBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports